"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _futuresOrderFormActions = require("../../redux/futures/actions/futuresOrderFormActions");
var _config = _interopRequireDefault(require("../../config"));
var _futuresOrdersSelectors = require("../../redux/futures/selectors/futuresOrdersSelectors");
var _selectors = require("../../redux/futures/selectors");
var _DepthChartComponent = _interopRequireDefault(require("./DepthChartComponent"));
var _excluded = ["selectedInstrument"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var depthChartConfig = _config["default"].DepthChart;
var DepthChart = function DepthChart(_ref) {
  var selectedInstrument = _ref.selectedInstrument,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!selectedInstrument) return null;
  return /*#__PURE__*/_react["default"].createElement(_DepthChartComponent["default"], _extends({}, props, {
    selectedInstrument: selectedInstrument
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    level2: (0, _futuresOrdersSelectors.selectLevel2State)(state),
    fetching: (0, _futuresOrdersSelectors.futuresLevel2LoadingSelector)(state),
    DepthChart: depthChartConfig,
    selectedInstrument: (0, _selectors.futuresSelectedInstrumentSelector)(state)
  };
};
var mapDispatchToProps = {
  buyPriceClicked: function buyPriceClicked(price) {
    return (0, _futuresOrderFormActions.buyPriceClicked)({
      price: price
    });
  },
  sellPriceClicked: function sellPriceClicked(price) {
    return (0, _futuresOrderFormActions.sellPriceClicked)({
      price: price
    });
  }
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DepthChart);